import pcbanglogo from './pcbanglogo.png'
import axios from 'axios';
import { useState } from 'react';
import { setCookies, getBearerToken } from './util';
import InputPassword from './InputPassword';

var integer = 0

function loadingMessage() {
	if (loading) {
		var rem = 7
		if (loading)
			setMessage("Logging in\u00A0" + "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0...\u00A0\u00A0\u00A0\u00A0\u00A0".substring(rem - integer, 5 + rem - integer))
		integer += 1
		integer %= rem
		if (loading)
			setTimeout(loadingMessage, 75)
	}
}

function handleLogin(e) {
	var e_identifier = document.getElementById('user')
	var e_password = document.getElementById('pass')
	var identifier = e_identifier.value;
	var password = e_password.value;
	e.preventDefault();
	if (!(identifier !== "" && password !== "")) {
		if (identifier === "")
			setUnameph("This field is required")
		if (password === "")
			setPaswdph("This field is required")
		setMessage("Please fill the required fields")
		return
	}
	// console.log(identifier)
	// console.log(password)
	// var loop = true
	setLoading(true)
	loadingMessage()
	axios.post(
		"https://api.pcbang.ma/api/auth/local/",
		{
			identifier: identifier,
			password: password
		}
	).then(response => {
		console.log(response)
		if (response.status === 200 /* && response.statusText === "OK" */) {
			var data = response.data;
			console.log(document.location)
			axios.get(
				"https://api.pcbang.ma/api/users/me",
				{
					params: {
						populate: "avatar,role"
					},
					headers: {
						Authorization: getBearerToken(data.jwt)
					}
				}
			).then((secondResponse) => {
				let sdata = secondResponse.data
				if (secondResponse.status === 200) {
					setLoading(false)
					setMessage("")
					let cookieobj = {
						jwt: data?.jwt,
						id: data?.user?.id,
						username: data?.user?.username,
						author: data?.user?.name,
						blocked: data?.user?.blocked,
						confirmed: data?.user?.confirmed,
						email: data?.user?.email,
						loggedIn: true,
						role: sdata?.role?.name,
						pfp: sdata?.avatar?.url
					} 
					setCookies(cookieobj)
				}
			})
		}
	}).catch((err) => {
		var { response } = err
		// return err.response
		console.log("errooooooor")
		console.log(err)
		setLoading(false)
		if (response && response.status === 400) {
			setMessage("Invalid credentials")
		}
		else {
			setMessage("An error occured while trying to log in")
		}
	})
}

function handleMouseUp(e) {
	e.target.removeAttribute("style")
}

function handleMouseDown(e) {
	e.target.style.backgroundColor = "#d20072"
	e.target.style.color = "#110011"
}

let unameph, setUnameph
let paswdph, setPaswdph
let message, setMessage
let loading, setLoading

const Login = () => {
	[unameph, setUnameph] = useState("");
	[paswdph, setPaswdph] = useState("");
	[message, setMessage] = useState("");
	[loading, setLoading] = useState(true);
	return (
		<div className="login pagebody">
			<div className="mainbody">
				<div className="navpad"></div>
				<div className="parent">
					<div className="hero">
						<img src={pcbanglogo} alt="" className="logo" />
						<div className="container headings">
							<h1 className="pcbang">PC&nbsp;BANG</h1>
							<h1 className="login">LOG&nbsp;IN</h1>
						</div>
					</div>
					<form method='POST'>
						<div className="input-container">
							<div className="title username">EMAIL/USERNAME</div>
							<input type="text" name="uname" required id='user' placeholder={unameph} />
						</div>
						<div className="input-container">
							<div className="title password">PASSWORD</div>
							<InputPassword type="password" name="pass" required id='pass' placeholder={paswdph} />
						</div>
						<div className="button-container">
							<div className="message">{message}</div>
							<input type="submit" className='submitbutton' value={"Log In"}
								onClick={handleLogin}
								onMouseDown={handleMouseDown}
								onMouseUp={handleMouseUp}
								onMouseLeave={handleMouseUp}
							/>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}

export default Login;